import Axios from "axios";

export const SelectFacCod = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(

      `https://www.24-crm.tn/webservice/api/bCDVCLIs?typpe=FC&codep=&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "FAC_COD", payload: response.data });
    });
  };
};
export const SelectFacCodFF = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/bCDVCLIs?typpe=FF&codep=&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "FAC_COD_FF", payload: response.data });
    });
  };
};
